class CrossSellPopup {
	constructor() {
		this.sliderInstance = undefined;
		this.sliderPrefix = 'crossell__';
		this.slideTransitionSpeed = 500;
		this.animationDuration = 0.5;
		this.expandedProducts = new Set();

		this.classes = {
			crossSellEl: 'crossell',
			sliderOuter: 'popup-sticks__slider-outer',
			pagination: 'pagination',
			bullet: 'pagination__bullet',
			bulletActive: 'pagination__bullet--active',
			

			status: {
				expanded: "is-expanded",
				active: "is-active",
				expanded: "is-expanded",
				visible: "is-visible",
			}
		};

		this.items = document.querySelectorAll(`.${this.classes.crossSellEl}`);


		this.init();
	}

	init() {
		this.swiperInit();
		this.handleExpand();
		this.watchCartState();
		this.getInititalExpandedProduct();

		// cart page
		this.handleTitleSelect();
		this.handleMobilePopup();
	}
	reinit() {
		console.log('cross sell reinit');
		this.updateDomElements();
		this.swiperInit();
		this.handleExpand();
		this.restoreExpandedProductsState();
		this.updateCartRecommended();
		this.updateCountersInPopup();
		// this.watchCartState();
	}

	getInititalExpandedProduct() {
		// console.log('getInititalExpandedProduct()');
		// console.log('this.expandedProducts', this.expandedProducts);

		this.items.forEach((item) => {
			if (item.classList.contains(this.classes.status.expanded)) {
				this.expandedProducts.add(item.dataset.productId);
			}
		});

		// console.log('this.expandedProducts', this.expandedProducts);
	}

	restoreExpandedProductsState() {
		console.log('restoreExpandedProductsState()');


		this.items.forEach((item) => {
			const productId = item.dataset.productId;
			const expandableContent = item.querySelector('.js-cs-content');
			// console.log('productId');

			if (this.expandedProducts.has(productId)) {
				item.classList.add(this.classes.status.expanded);

				if (expandableContent) {
					expandableContent.style.height = 'auto';
				}
			}
		});
	}

	updateDomElements() {
		this.items = document.querySelectorAll(`.${this.classes.crossSellEl}`);
	}
	swiperInit() {
		this.items.forEach((crossSellItem) => {
			let sliderElement = crossSellItem.querySelector(`.${this.sliderPrefix}slider`);
			if (sliderElement) {
				let paginationElement = crossSellItem.querySelector(`.${this.classes.pagination}`);
				this.sliderInstance = new Swiper(sliderElement, {
					wrapperClass: `${this.sliderPrefix}slider-track`,
					slideClass: `${this.sliderPrefix}slide`,
					slideActiveClass: `${this.sliderPrefix}slide--active`,
					slidesPerGroup: 2,
					slidesPerView: 'auto',
					speed: this.slideTransitionSpeed,
					spaceBetween: 10,
					pagination: {
						el: paginationElement,
						type: 'bullets',
						clickable: true,
						bulletClass: this.classes.bullet,
						bulletActiveClass: this.classes.bulletActive
					}
				});
			}
		});
	}


	watchCartState() {
		// console.log('watchCartState()');

		document.addEventListener('product:added', (event) => {
			// console.log('addCustomEventListeners() - product:added - Product added:', event.detail);
		});
		document.addEventListener('product:removed', (event) => {
			// console.log('Product removed:', event.detail.variantId);
		});
		document.addEventListener('cart:update', (event) => {
			// console.log('Product removed:', event.detail.variantId);
			// console.log('cart updated');
			this.reinit();
		});
		
	}


	handleExpand() {
		// console.log('handleExpand()');
		// console.log('items: ', this.items);
		this.items.forEach((item) => {
			const heading = item.querySelector('.js-cs-heading');
			const expandableContent = item.querySelector('.js-cs-content');
			const productId = item.dataset.productId;

			// console.log(expandableContent);

			if (heading && expandableContent) {
				heading.addEventListener('click', (e) => {
					e.preventDefault();

					// console.log('tab click');
					// console.log('productId', productId);
					
					let isExpanded = item.classList.toggle(this.classes.status.expanded);
					// console.log({isExpanded});

					gsap.to(expandableContent, {
						height: isExpanded ? 'auto' : 0,
						duration: this.animationDuration
					});

					if (isExpanded) {
						this.expandedProducts.add(productId);
					} else {
						this.expandedProducts.delete(productId);
					}

					// console.log('this.expandedProducts', this.expandedProducts);
					
				});
			}
		});
	}

	handleMobilePopup() {
		const popup = document.querySelector('.popup-cs');

		// console.log('handleMobilePopup()');
		// console.log(popup);

		if (!popup) return;
		const popupTitleDeviceName = popup.querySelector('.js-cs-device-name');

		const closeButtons = popup.querySelectorAll('.js-close-popup');
		
		closeButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
			
				// console.log('close popup');
				popup.classList.remove(this.classes.status.visible);
				document.body.classList.remove('overflow');
			});
		});

		document.addEventListener('click', (e) => {
			if (e.target.closest('.crossell__btn-mobile')) {
				e.preventDefault();

				console.log('open cross sell');

				popup.classList.add(this.classes.status.visible);
				document.body.classList.add('overflow');

				const openButton = e.target.closest('.crossell__btn-mobile')
				const type = openButton.dataset.type;
				const deviceName = openButton.querySelector('.js-device-button').innerText;

				console.log({deviceName});

				popupTitleDeviceName.innerText = deviceName;

				if (type == 'demi') {
					popup.classList.add('sticks-demi');
					popup.classList.remove('sticks-nano');
				}

				if (type == 'nano') {
					popup.classList.add('sticks-nano');
					popup.classList.remove('sticks-demi');
				}
				

				// console.log(openButton);
				// console.log(type);

			}
		});


	}

	handleTitleSelect() {
		// console.log('handleTitleSelect()');
		const wrappers = document.querySelectorAll('.product-slider-inner');

		wrappers.forEach((wrapper) => {
			const select = wrapper.querySelector('.device-select');
			console.log(select);

			if (select) {
				const label = select.querySelector('.device-select__value');
				const list = select.querySelector('.device-select__list');
				const items = select.querySelectorAll('.device-select__list-item');

				select.addEventListener('click', (e) => {
					// console.log('select.click');
					e.preventDefault();
					select.classList.toggle(this.classes.status.expanded);

					if (e.target.closest('.device-select__list-item')) {
						// console.log('item click');
						const item = e.target.closest('.device-select__list-item');
						// console.log('item:', item);

						if (!item.classList.contains(this.classes.status.active)) {
							console.log('change type');
							this.setActiveType(item.innerText, item.dataset.type);
							$('.js-product-slider').slick('setPosition');
						}
					}
				});
			}
		});
	}

	setActiveType(title, type) {
		// console.log('setActiveType');
		// console.log({title, type});
		this.initAnnBarSlider();

		const titleTargets = document.querySelectorAll('.js-device-name');
		titleTargets.forEach((titleTarget) => {
			titleTarget.innerText = title;
		});

		const labels = document.querySelectorAll('.device-select__value');
		labels.forEach((label) => {
			label.innerText = title
		});

		const selectEls = document.querySelectorAll('.device-select');
		selectEls.forEach((select) => {
			const items = select.querySelectorAll('.device-select__list-item');
			items.forEach((item) => {

				// console.log({item.innerText, title});

				if (item.innerText == title) {
					item.classList.add(this.classes.status.active);
				} else {
					item.classList.remove(this.classes.status.active);
				}
			});
		});


		const wrappers = document.querySelectorAll('.product-slider-inner');
		wrappers.forEach((wrapper) => {
			if (wrapper.dataset.type == type) {
				wrapper.classList.add(this.classes.status.active);
			} else {
				wrapper.classList.remove(this.classes.status.active);
			}
		});

	}


	updateCartRecommended() {
		// console.log('updateCartRecommended()');

		if (!window.location.href.includes('/cart')) return;

		const cartDevices = document.querySelectorAll('cart-item[data-device]');
		const activeSlider = document.querySelector('.product-slider-inner.is-active');
		if (!activeSlider) return;
		const cartSelectItems = activeSlider.querySelectorAll('.device-select__list-item');

		// console.log('cartDevices', cartDevices);
		// console.log('cartSelectItems', cartSelectItems);

		if (cartDevices.length === cartSelectItems.length) {
			console.log('devices not changed');
			return;
		}

		console.log('device was removed');
		let removedDeviceName = null;
		let removedDeviceWasActive = false;

		cartSelectItems.forEach((selectItem) => {
			const name = selectItem.innerText;
			const isRemoved = !Array.from(cartDevices).some(device => device.dataset.name === name);

			console.log('isRemoved:', isRemoved, '| selectItem:', name);

			if (isRemoved) {
				removedDeviceName = name;
				removedDeviceWasActive = selectItem.classList.contains('is-active');
			}
		});

		if (removedDeviceName) {
			console.log('removedDeviceName:', removedDeviceName);
			document.querySelectorAll('.device-select').forEach((select) => {
				select.querySelectorAll('.device-select__list-item').forEach((item) => {
					if (item.innerText === removedDeviceName) {
						console.log('Removing item:', item);
						item.remove();
					}
				});
			});

			if (removedDeviceWasActive) {
				console.log('removedDeviceWasActive:', removedDeviceWasActive);
				const firstSelectItem = document.querySelector('.device-select__list-item');
				if (firstSelectItem) {
					console.log('Clicking firstSelectItem:', firstSelectItem);
					firstSelectItem.click();
					firstSelectItem.closest('.device-select').classList.remove('is-expanded');
					
					// if (firstSelectItem.nextElementSibling === null) {
					// 	document.querySelectorAll('.device-select').forEach((select) => {
					// 		select.remove();
					// 	});
					// }
				}
			}
		}
	}
	
	updateCountersInPopup() {
		// console.log('updateCountersInPopup()');

		if (window.location.href.includes('/cart')) return;

		const cartItems = document.querySelectorAll('.pop-cart cart-item');

		const cartItemCounterInputClass = 'quan-input';

		// console.log('cartItems: ', cartItems);

		const popupProductCards = document.querySelectorAll('.popup-sticks__product-item');
		popupProductCards.forEach((card) => {
			const counter = card.querySelector('.cart-counter');
			const title = card.dataset.title.trim();
			// console.log('Processing card with title:', title);

			let found = false;
			cartItems.forEach((cartItem) => {
				const cartItemTitle = cartItem.querySelector('.cart-item-title').innerText.trim();
				// console.log('Comparing with cart item title:', cartItemTitle);
				if (cartItemTitle === title) {
					const qty = cartItem.querySelector(`.${cartItemCounterInputClass}`).value;
					counter.innerHTML = qty;
					found = true;
					console.log('Match found. Quantity set to:', qty);
				}
			});
			if (!found) {
				counter.innerHTML = '';
				counter.style.display = 'none';
				// console.log('No match found. Counter value set to blank.');
			}
		});
	}

	initAnnBarSlider () { // delisting ann bar on product cards
		if ($('.new-product-announcement-bar').length) {
			const swiper = new Swiper('.new-product-announcement-bar', {
				slidesPerView: 'auto',
				loop: true,
				freeModeMomentum: false,
				speed: 5000,
				events: false,
				allowTouchMove: false,
				changeDir: false,
				useTransform: true,
				cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
				scrollbar: {
					draggable: false,
				},
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
				}
			});
		}
	}
}

new CrossSellPopup();